import { adminRoutes } from 'app/constants/routes';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import { CarrierActions } from './CarrierActionsRouteComponents';

export const carrierActionsRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: CarrierActions,
    path: adminRoutes.carrierActions,
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
